import { Component } from 'react'
import PropTypes from 'prop-types'
import { getScrollTracker } from './scroll-tracker'

export default class RenderOnScroll extends Component {
  scrollTracker = null

  constructor(props) {
    super(props)
    this.state = {
      showChildren: false,
    }
  }

  componentDidMount() {
    const { offsetClasses } = this.props
    window.addEventListener('scroll', this.onScroll, false)
    this.scrollTracker = getScrollTracker(...offsetClasses)
  }

  componentWillUnmount() {
    this.scrollTracker.resetScrollArea()
    window.removeEventListener('scroll', this.onScroll, false)
  }

  scrollProgress = () => {
    const { percent, containerRef } = this.props
    if (percent) {
      return this.scrollTracker.getPercentScrolled(containerRef())
    }
    return this.scrollTracker.getDistanceScrolled()
  }

  onScroll = () => {
    const { showChildren } = this.state
    const { triggerY } = this.props
    const belowTrigger = this.scrollProgress() > triggerY
    if (belowTrigger && !showChildren) {
      this.setState({ showChildren: true })
    }
  }

  render() {
    const { showChildren } = this.state
    const { children } = this.props
    return showChildren ? children : null
  }
}

RenderOnScroll.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  triggerY: PropTypes.number,
  containerRef: PropTypes.func,
  offsetClasses: PropTypes.arrayOf(PropTypes.string).isRequired,
  percent: PropTypes.bool,
}

RenderOnScroll.defaultProps = {
  containerRef: null,
  triggerY: 25,
  percent: true,
}
